export const PlayerTech = {
    BAM: 'bam',
    BRIGHTCOVE: 'brightcove'
};

export default {
    PlayerTech
};



// WEBPACK FOOTER //
// ./app/webapp/common/video-player/constants.js